import { useEffect, useState } from 'react'
import {
    AUDIT_NOT_FOUND_MESSAGE,
    ErrorConstant,
    InspectionService,
} from 'utility'

export const GetAuditById = id => {
    const [data, setData] = useState({})
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const fetchData = async () => {
        try {
            setLoading(true)
            setError('')
            const audit = await InspectionService.getAudit(id)
            setData(audit)
        } catch (err) {
            // Cross-tenant / non-existent / kill-switch OFF → 404 (no info leak)
            if (err?.status === 404) {
                setError(AUDIT_NOT_FOUND_MESSAGE)
            } else {
                setError(ErrorConstant.default)
            }
            setData({})
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            fetchData()
        }
    }, [id])

    const refetch = () => {
        fetchData()
    }

    return { data, setData, error, loading, refetch }
}

export const GetInspectionReport = (id, customeRepport = false) => {
    const [data, setData] = useState({})
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                let audit = {}
                if (customeRepport) {
                    audit = await InspectionService.getCustomeReport(id)
                } else {
                    audit = await InspectionService.getReport(id)
                }
                setData(audit)
            } catch {
                setError(ErrorConstant.default)
            } finally {
                setLoading(false)
            }
        }
        if (id) {
            fetchData()
        }
    }, [id])

    return { data, setData, error, loading }
}

export const GetPublicInspection = tokenId => {
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                console.log('Fetching public inspection with tokenId:', tokenId)
                const response = await InspectionService.publicInspection({
                    tokenId,
                })
                console.log('Public inspection response:', response)
                setData(response)
            } catch (err) {
                console.error('Error fetching public inspection:', err)
                setError(err.message || 'Failed to load inspection')
            } finally {
                setLoading(false)
            }
        }

        if (tokenId) {
            fetchData()
        }
    }, [tokenId])

    const submitPublicInspection = async inspectionData => {
        console.log('Submitting public inspection:', inspectionData)
        try {
            // Send the data directly without any wrapping
            const response = await InspectionService.submitPublicInspection(inspectionData)
            console.log('Public inspection submission response:', response)
            return response
        } catch (err) {
            console.error('Error submitting public inspection:', err)
            throw err
        }
    }

    return {
        data,
        loading,
        error,
        setData,
        submitPublicInspection,
    }
}

export const useQuestionComment = () => {
    const submitComment = async commentData => {
        try {
            await InspectionService.questionComment(commentData)
        } catch (err) {
            console.error('Error saving comment:', err)
        }
    }

    return { submitComment }
}
